const updateButton = (button, emptyFields) => {
  if (emptyFields.size === 0) {
    button.removeAttribute('disabled');
  } else {
    button.setAttribute('disabled', true);
  }
};

export const disableSendButtonDynamically = (actionPanelEl, button) => {
  const emptyFields = new Set();

  // all supported fields with 'required' attribute
  const requiredFields = actionPanelEl.querySelectorAll('input[required], select[required], textarea[required]');
  requiredFields.forEach(field => {
    if (!field.value) {
      emptyFields.add(field);
    }
    const detectChange = () => {
      // If there's text, enable the button
      if (field.value.trim() !== '') {
        emptyFields.delete(field);
      } else {
        emptyFields.add(field);
      }
      updateButton(button, emptyFields);
    };
    field.addEventListener('input', detectChange);
    // for select2 fields
    $(field).on('change', detectChange);
  });

  updateButton(button, emptyFields);
};
